import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrowserStorageService {
  /** Reads a stored value, returning null if storage is unavailable or the read fails. */
  getItem(key: string): string | null {
    try {
      return this.storage()?.getItem(key) ?? null;
    } catch (error) {
      console.warn(`Could not read browser storage key "${key}".`, error);
      return null;
    }
  }

  /** Writes a value to browser storage when available. */
  setItem(key: string, value: string): void {
    try {
      this.storage()?.setItem(key, value);
    } catch (error) {
      console.warn(`Could not write browser storage key "${key}".`, error);
    }
  }

  /** Removes a stored value when browser storage is available. */
  removeItem(key: string): void {
    try {
      this.storage()?.removeItem(key);
    } catch (error) {
      console.warn(`Could not remove browser storage key "${key}".`, error);
    }
  }

  /** Removes keys with the given prefix, optionally preserving one key. */
  removeItemsWithPrefix(prefix: string, exceptKey?: string): void {
    try {
      const storage = this.storage();
      if (!storage) return;
      for (let index = storage.length - 1; index >= 0; index--) {
        const key = storage.key(index);
        if (key?.startsWith(prefix) && key !== exceptKey) storage.removeItem(key);
      }
    } catch (error) {
      console.warn(`Could not remove browser storage keys with prefix "${prefix}".`, error);
    }
  }

  /** Returns local storage when accessible, or null when unavailable. */
  private storage(): Storage | null {
    try {
      return typeof globalThis.localStorage === 'undefined' ? null : globalThis.localStorage;
    } catch (error) {
      console.warn('Browser storage is unavailable.', error);
      return null;
    }
  }
}
